<template>
  <div id="app">
    <router-view></router-view>
    <!-- ukey需要的DOM 放在这里是为了解决ie用户刷新页面导致ukey失效 -->
    <object
      classid="clsid:2CD78E57-000B-4F03-AF36-59D84E9B2763"
      style="display: none;"
      width=0
      height=0
      id="CBIB">
    </object>
    <!-- 签名控件所需DOM -->
    <p id="sm_area" v-html="smAreaData">&nbsp;</p>
  </div>
</template>
<script>
import { getHrefParams } from '@/utils/utils'
import { mapGetters, mapMutations } from 'vuex'
import { SampleAtlCtrl } from '@/utils/sampleAtlCtrl'
import { needWebsock } from '@/utils/USBKeyUtil'
import { signObj } from '@/utils/plugins/SignMessenger'
export default {
  data () {
    return {
      // 签名控件所需
      smAreaData: null
    }
  },
  computed: {
    ...mapGetters({
      lang: 'lang'
    })
  },
  created () {
    this.setLanguage()
    // 保证每次刷新页面之后 Ukey功能正常使用
    if (this.$_core.signDataEnabled) {
      this.handleInitUkey()
      this.handleInitSignData()
    }
  },
  methods: {
    ...mapMutations('app', ['SET_LANG']),
    setLanguage () {
      // 从官网接收参数 https://www.cbibank.com/
      const { lang } = getHrefParams()
      const localLang = lang || this.lang || 'zh-CN'
      this.$i18n.locale = localLang
      this.SET_LANG(localLang)
    },
    /*
      由于刷新页面时，会导致全局的ukeyCtrl丢失，造成ukey不能成功调起。所以这里对window.ukeyCtrl进行重新赋值。另外注意IE浏览器与其他浏览器的不同之处：
      IE:寻找对应id的DOM，进行初始化。整个过程是同步的。所以旧代码中能直接拿到lRet。
      Chrome:异步回调。旧代码处理异步回调的方式不够优雅，它是将lRet这个值挂载到了window上。
      这里的代码主要是初始化，涉及到ukey与签名控件的交互，依然在USEBKeyUtil.js文件的GetCertDN方法中。
    */
    handleInitUkey () {
      if (!needWebsock()) {
        window.ukeyCtrl = document.getElementById('CBIB')
        // window.lRet = window.ukeyCtrl.GetCertDN()
      } else {
        window.ukeyCtrl = new SampleAtlCtrl('{2CD78E57-000B-4F03-AF36-59D84E9B2763}')
        // 暂时做异步处理 否则报错'connecting state'
        setTimeout(() => {
          window.ukeyCtrl.GetCertDN((result, response) => {
            window.lRet = response
          })
        }, 1000)
      }
    },
    // 签名控件初始化
    handleInitSignData () {
      this.smAreaData = signObj.createTag()
      signObj.getVersion()
    }
  }
}
</script>

<style lang="less">
#app {
  min-width: 1360px;
}
</style>
